export default __webpack_public_path__ + "static/media/MetafightSemiFinal-min.7456a16d.png";